/**
 * Texts for User Training page
 */
export const userTrainingPageText = {
    title: 'User Training - CamAPS FX',
    titleMeta: 'Comprehensive training resources for CamAPS FX users',
    descriptionMeta: 'Access complete training materials, video tutorials, user guides, and webinars to help you get the most out of CamAPS FX.',
    keywords:
        'camaps fx user training, camaps training, diabetes training, insulin pump training, user guide, video tutorials, ' +
        'cgm training, automated insulin delivery training, type 1 diabetes education',
    localeMeta: 'en_gb',

    mainHeader: 'User training',
    mainSubHeader: 'Complete the essential in-app training before using the CamAPS FX app.',

    gettingStartedHeader: 'Getting started',
    step1Title: '<strong>Step 1:</strong><br/>Download the app',
    step2Title: '<strong>Step 2:</strong><br/>Create an account',
    step3Title: '<strong>Step 3:</strong><br/>Begin the in-app essential training',
    step4Title: '<strong>Step 4:</strong><br/>Pair with your chosen pump and CGM (with the approval of your healthcare team) or explore the app with <strong>Virtual Mode</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Need help installing the app?',
    supportSectionText: 'Visit our support section for guidance',
    supportButtonText: 'SUPPORT',
    findOutMoreButtonText: 'FIND OUT MORE',

    additionalResourcesTitle: 'Additional resources',
    additionalResourcesSubtitle: 'Learn through step-by-step visuals or watch expert-led sessions on using the app.',
    
    animationsTitle: 'Animations',
    animationsDescription: 'These \'bite-sized\' short animations have been designed to answer a few of CamAPS FX\'s most common questions.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinars',
    webinarsDescription: 'These webinars are useful for people with type 1 diabetes, their families and caregivers, as well as teachers, education support staff and healthcare professionals. They are offered in English.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Factsheets',
    factsheetsDescription: 'This series of factsheets are designed to be starting guides. They do not replace or supercede medical advice and support from a person\'s diabetes team.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'In-App Training',
    inAppTrainingText: 'Start with the essential training built into the CamAPS FX app. This interactive training will guide you through all the key features and functions you need to know.<br/><br/><strong>To access:</strong> Download the CamAPS FX app and create an account to begin your in-app training journey.',

    gettingStartedText: '<strong>Step 1:</strong> Download the CamAPS FX app from your device\'s app store<br/><strong>Step 2:</strong> Create your account<br/><strong>Step 3:</strong> Complete the in-app training modules<br/><strong>Step 4:</strong> Connect your insulin pump and CGM<br/><strong>Step 5:</strong> Start your CamAPS FX journey',

    trainingResourcesHeader: 'Additional Training Resources',
    videoTutorialsText: 'Video Tutorials',
    videoTutorialsDesc: 'Watch step-by-step video guides covering setup, daily use, and troubleshooting.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'User Guides & Documentation',
    userGuidesDesc: 'Download comprehensive PDF guides and quick reference materials.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Live Webinars',
    webinarsDesc: 'Join expert-led training sessions and Q&A opportunities.',

    needHelpHeader: 'Need Help?',
    needHelpTextStart: 'If you need assistance or have questions, visit our',
    supportLinkText: 'Support',
    needHelpTextEnd: 'page for additional help and contact information.'
};

